module.exports = __webpack_public_path__ + "static/media/home_logo_en@3x.fb212307.png";